import { FC } from "react";
import { IIpSubnetCalculatorInputComponentProps } from "../models/ip-subnet-calculator-input-component.props";
import "./custom-input.scss";

const CustomInput: FC<IIpSubnetCalculatorInputComponentProps> = ({ type, label, options, value, onChange, onBlur, testId }) => {

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    onChange(text);
  }

  const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const text = e.target.value;
    onChange(text);
  }


  return (
    <div className="float-label">
      {type === "select" ? (
        <select
          className="custom-input"
          onChange={onSelectChange}
          value={value}
          data-testid={testId}
        >
          {
            options?.map((item: number | string) => (
              <option key={`${label}-${item}`} value={item}>{item}</option>
            ))
          }
        </select>
      ) : (
        <input
          type={type}
          className="custom-input"
          value={value}
          data-testid={testId}
          onBlur={(e) => onBlur && onBlur(e.target.value)}
          onChange={onInputChange}
        />
      )}
      <label
        className={value || value === 0 ? "custom-input--active" : "custom-input_label"}
      >
        {label}
      </label>
    </div>
  );
};

export default CustomInput;
